"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Vault_instances, _a, _Vault_isPrivateKey, _Vault_extensionRegistrationComplete, _Vault_valueWrappers, _Vault_wrapPrivateValue, _Vault_valueTransformers, _Vault_transformValue, _Vault_shieldingKey, _Vault_privateContents, _Vault_wrapperRevokers, _Vault_revokeWrapperForValue, _Vault_revokeWrapperForKey, _Vault_getUnwrapped, _Vault_unwrap, _Vault_sealed;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vault = void 0;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const jose = __importStar(require("jose"));
const ta = __importStar(require("type-assertions"));
const mapVault_1 = require("./mapVault");
const rawVault_1 = require("./rawVault");
const util_1 = require("./util");
ta.assert();
class Vault extends mapVault_1.MapVault {
    constructor(rawVault) {
        super(rawVault);
        _Vault_instances.add(this);
        //#endregion
        _Vault_shieldingKey.set(this, (() => __awaiter(this, void 0, void 0, function* () {
            const out = (yield util_1.crypto).subtle.generateKey({
                name: "AES-KW",
                length: 256,
            }, false, ["wrapKey", "unwrapKey"]);
            return util_1.revocable(out, this.addRevoker.bind(this));
        }))());
        _Vault_privateContents.set(this, void 0);
        _Vault_wrapperRevokers.set(this, new Map());
        _Vault_sealed.set(this, false);
        __classPrivateFieldSet(this, _Vault_privateContents, util_1.revocable(new Map(), (x) => this.addRevoker(x)), "f");
        this.addRevoker(() => this.clear());
    }
    //#region static
    static prepare(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapVault_1.MapVault.prepare(params);
        });
    }
    static create(password, sealed = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Vault.open(undefined, password, sealed);
        });
    }
    static open(id, password, sealed = true) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Vault.prepare();
            const out = new Vault(yield rawVault_1.RawVault.open(id, password));
            if (sealed)
                out.seal();
            if (id !== undefined && password !== undefined)
                yield out.load();
            return out;
        });
    }
    static thereCanBeOnlyOne(password, sealed = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const ids = yield Vault.list();
            if (ids.length === 0)
                throw new Error("can't find a vault");
            if (ids.length > 1)
                throw new Error(`expected a single vault; found ${ids.length}: ${ids}`);
            return yield Vault.open(ids[0], password, sealed);
        });
    }
    static extensionRegistrationComplete() {
        __classPrivateFieldSet(Vault, _a, true, "f", _Vault_extensionRegistrationComplete);
    }
    static registerValueWrapper(key, valueWrapper) {
        if (__classPrivateFieldGet(Vault, _a, "f", _Vault_extensionRegistrationComplete))
            throw new Error(`can't register value wrapper after registration is complete`);
        if (!__classPrivateFieldGet(Vault, _a, "m", _Vault_isPrivateKey).call(Vault, key))
            throw new TypeError(`can't set value wrapper for non-private key '${key}'`);
        if (__classPrivateFieldGet(Vault, _a, "f", _Vault_valueWrappers).has(key))
            throw new Error(`can't overwrite previously-set value wrapper for key '${key}'`);
        __classPrivateFieldGet(Vault, _a, "f", _Vault_valueWrappers).set(key, valueWrapper);
    }
    static registerValueTransformer(key, valueTransformer) {
        if (__classPrivateFieldGet(Vault, _a, "f", _Vault_extensionRegistrationComplete))
            throw new Error(`can't register value transformer after registration is complete`);
        if (!__classPrivateFieldGet(Vault, _a, "m", _Vault_isPrivateKey).call(Vault, key))
            throw new TypeError(`can't set value transformer for non-private key '${key}'`);
        if (__classPrivateFieldGet(Vault, _a, "f", _Vault_valueTransformers).has(key))
            throw new Error(`can't overwrite previously-set value transformer for key '${key}'`);
        __classPrivateFieldGet(Vault, _a, "f", _Vault_valueTransformers).set(key, valueTransformer);
    }
    clear() {
        __classPrivateFieldGet(this, _Vault_privateContents, "f").forEach((x) => __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_revokeWrapperForValue).call(this, x));
        __classPrivateFieldGet(this, _Vault_privateContents, "f").clear();
        __classPrivateFieldGet(this, _Vault_wrapperRevokers, "f").clear();
        super.clear();
    }
    delete(key) {
        __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_revokeWrapperForKey).call(this, key);
        __classPrivateFieldGet(this, _Vault_privateContents, "f").delete(key);
        return super.delete(key);
    }
    set(key, value) {
        value = __classPrivateFieldGet(Vault, _a, "m", _Vault_transformValue).call(Vault, key, value, this.addRevoker.bind(this));
        if (!__classPrivateFieldGet(Vault, _a, "m", _Vault_isPrivateKey).call(Vault, key))
            return super.set(key, value);
        __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_revokeWrapperForKey).call(this, key);
        __classPrivateFieldGet(this, _Vault_privateContents, "f").set(key, (() => __awaiter(this, void 0, void 0, function* () {
            const payload = util_1.encoder.encode(JSON.stringify(yield value));
            return new jose.FlattenedEncrypt(payload)
                .setProtectedHeader({
                alg: "A256KW",
                enc: "A256GCM",
            })
                .encrypt(yield __classPrivateFieldGet(this, _Vault_shieldingKey, "f"));
        }))());
        const wrapperRevoker = new (util_1.Revocable(class {
        }))();
        const wrapper = __classPrivateFieldGet(Vault, _a, "m", _Vault_wrapPrivateValue).call(Vault, key, value, (x) => wrapperRevoker.addRevoker(x));
        __classPrivateFieldGet(this, _Vault_wrapperRevokers, "f").set(key, () => wrapperRevoker.revoke());
        return super.set(key, wrapper);
    }
    seal() {
        __classPrivateFieldSet(this, _Vault_sealed, true, "f");
    }
    get sealed() {
        return __classPrivateFieldGet(this, _Vault_sealed, "f");
    }
    unwrap(addRevoker) {
        if (__classPrivateFieldGet(this, _Vault_sealed, "f"))
            throw new Error("can't unwrap a sealed vault");
        return __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_unwrap).call(this, (x) => {
            this.addRevoker(x);
            addRevoker === null || addRevoker === void 0 ? void 0 : addRevoker(x);
        });
    }
    load() {
        const _super = Object.create(null, {
            load: { get: () => super.load }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.load.call(this, (entries) => __awaiter(this, void 0, void 0, function* () {
                this.clear();
                entries.forEach(([k, v]) => this.set(k, v));
            }));
            return this;
        });
    }
    save() {
        const _super = Object.create(null, {
            save: { get: () => super.save }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const unwrappedRevoker = new (util_1.Revocable(class {
            }))();
            const unwrapped = __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_unwrap).call(this, (x) => unwrappedRevoker.addRevoker(x));
            yield _super.save.call(this, () => __awaiter(this, void 0, void 0, function* () {
                return yield Promise.all(Array.from(unwrapped.entries()).map(([k, v]) => __awaiter(this, void 0, void 0, function* () { return [k, yield v]; })));
            }));
            unwrappedRevoker.revoke();
            return this;
        });
    }
}
exports.Vault = Vault;
_a = Vault, _Vault_shieldingKey = new WeakMap(), _Vault_privateContents = new WeakMap(), _Vault_wrapperRevokers = new WeakMap(), _Vault_sealed = new WeakMap(), _Vault_instances = new WeakSet(), _Vault_isPrivateKey = function _Vault_isPrivateKey(key) {
    return String(key).startsWith("#");
}, _Vault_wrapPrivateValue = function _Vault_wrapPrivateValue(key, value, addRevoker) {
    if (!__classPrivateFieldGet(this, _a, "m", _Vault_isPrivateKey).call(this, key))
        throw new TypeError(`can't wrap value with non-private key '${key}'`);
    const valueWrapper = __classPrivateFieldGet(this, _a, "f", _Vault_valueWrappers).get(key);
    // if (!valueWrapper) throw new Error(`private key '${key}' does not have a registered value wrapper`)
    if (!valueWrapper)
        return core.untouchable(`no value wrapper registered for private key '${key}'`);
    return (() => __awaiter(this, void 0, void 0, function* () { return yield valueWrapper(yield value, addRevoker); }))();
}, _Vault_transformValue = function _Vault_transformValue(key, value, addRevoker) {
    const valueTransformer = __classPrivateFieldGet(this, _a, "f", _Vault_valueTransformers).get(key);
    if (!valueTransformer)
        return value;
    return (() => __awaiter(this, void 0, void 0, function* () { return yield valueTransformer(yield value, addRevoker); }))();
}, _Vault_revokeWrapperForValue = function _Vault_revokeWrapperForValue(x) {
    var _b;
    (_b = __classPrivateFieldGet(this, _Vault_wrapperRevokers, "f").get(x)) === null || _b === void 0 ? void 0 : _b();
    __classPrivateFieldGet(this, _Vault_wrapperRevokers, "f").delete(x);
}, _Vault_revokeWrapperForKey = function _Vault_revokeWrapperForKey(key) {
    __classPrivateFieldGet(this, _Vault_instances, "m", _Vault_revokeWrapperForValue).call(this, __classPrivateFieldGet(this, _Vault_privateContents, "f").get(key));
}, _Vault_getUnwrapped = function _Vault_getUnwrapped(key) {
    if (!__classPrivateFieldGet(Vault, _a, "m", _Vault_isPrivateKey).call(Vault, key))
        return this.get(key);
    const jwe = __classPrivateFieldGet(this, _Vault_privateContents, "f").get(key);
    if (!jwe)
        return undefined;
    return (() => __awaiter(this, void 0, void 0, function* () {
        const decryptResult = yield jose.flattenedDecrypt(yield jwe, yield __classPrivateFieldGet(this, _Vault_shieldingKey, "f"), {
            keyManagementAlgorithms: ["A256KW"],
            contentEncryptionAlgorithms: ["A256GCM"],
        });
        const out = JSON.parse(util_1.decoder.decode(decryptResult.plaintext));
        return out;
    }))();
}, _Vault_unwrap = function _Vault_unwrap(addRevoker = (x) => this.addRevoker(x)) {
    const self = this;
    const { proxy, revoke } = Proxy.revocable(self, {
        get(t, p, r) {
            switch (p) {
                case "get":
                    return __classPrivateFieldGet(self, _Vault_instances, "m", _Vault_getUnwrapped).bind(self);
                case "values":
                    return () => Array.from(self.keys()).map((k) => __classPrivateFieldGet(self, _Vault_instances, "m", _Vault_getUnwrapped).call(self, k));
                case "entries":
                    return () => Array.from(self.keys()).map((k) => [k, __classPrivateFieldGet(self, _Vault_instances, "m", _Vault_getUnwrapped).call(self, k)]);
                case "entriesAsync":
                    return () => Promise.all(Array.from(self.keys()).map((k) => __awaiter(this, void 0, void 0, function* () { return [k, yield __classPrivateFieldGet(self, _Vault_instances, "m", _Vault_getUnwrapped).call(self, k)]; })));
                case "forEach":
                    return (callbackFn, thisArg) => {
                        for (const key of self.keys()) {
                            callbackFn.call(thisArg, __classPrivateFieldGet(self, _Vault_instances, "m", _Vault_getUnwrapped).call(self, key), key, self);
                        }
                    };
                default: {
                    const out = Reflect.get(t, p, r);
                    // if (!String(p).startsWith("_") && typeof out === "function") return out.bind(t);
                    return out;
                }
            }
        },
    });
    addRevoker(revoke);
    return proxy;
};
_Vault_extensionRegistrationComplete = { value: false };
_Vault_valueWrappers = { value: new Map() };
_Vault_valueTransformers = { value: new Map() };
Object.freeze(Vault);
Object.freeze(Vault.prototype);
Object.freeze(Object.getPrototypeOf(Vault));
